<div class="video" *ngIf="!!vimeoId && !!backgroundImage">
  <iframe scrolling="no" class="cover-image-background embed-responsive-item video" [style.background-url]="safeStyle('url(' + backgroundImage + ')')" [src]="'https://player.vimeo.com/video/' + vimeoId + '?background=1&autoplay=1&loop=1&byline=0&title=0&dnt=1&muted=1' | html:'resourceUrl'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" autoplay loop muted playsinline title="Home Page Video" aria-label="Home Page Video">
    <div class="container m-0 p-0">
      <ng-content></ng-content>
    </div>
  </iframe>
</div>
